/**
 * FlipGuestbookCapture — canonical name for the booth's flip-book
 * guestbook entry flow. Explicit import + default re-export so the
 * bundler resolves the symbol deterministically.
 */
import BoothFlipGuestbook from './BoothFlipGuestbook';
export default BoothFlipGuestbook;
